export function trackPixel(event, params) {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', event, params);
    }
}
